import React from 'react';
import { usePredictions } from '../context/PredictionsContext';

const MobileMenu = () => {
  const { state, dispatch } = usePredictions();
  const { isChartPaneOpen, isHistoryPaneOpen } = state;
  
  const handlePositionsClick = () => {
   // console.log('Positions clicked'); // DEBUG
    dispatch({ type: 'SET_CHART_PANE', payload: false });
    dispatch({ type: 'SET_HISTORY_PANE', payload: false });
  };
  
  const handleChartClick = () => {
   // console.log('Chart clicked'); // DEBUG
    dispatch({ type: 'SET_CHART_PANE', payload: true });
    dispatch({ type: 'SET_HISTORY_PANE', payload: false });
  };
  
  const handleHistoryClick = () => {
   // console.log('History clicked'); // DEBUG
    dispatch({ type: 'SET_CHART_PANE', payload: false });
    dispatch({ type: 'SET_HISTORY_PANE', payload: true });
  };

  return (
    <div 
      className="fixed bottom-0 left-0 right-0 bg-[#0d0d0d] border-t border-[#7900ff]/30 p-3 flex justify-around z-50"
      style={{
        /* Garantir que está sempre visível e clicável */
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        pointerEvents: 'auto',
        touchAction: 'manipulation',
        /* Evitar que outros elementos sobreponham */
        boxShadow: '0 -2px 10px rgba(0,0,0,0.3)'
      }}
    >
      <button
        onClick={handlePositionsClick}
        className={`flex flex-col items-center px-4 py-3 rounded-lg transition-all active:scale-95 ${
          !isChartPaneOpen && !isHistoryPaneOpen ? 'bg-[#7900ff]/20 text-[#7900ff]' : 'text-gray-400'
        }`}
        style={{
          /* Botão clicável */
          minHeight: '60px',
          minWidth: '60px',
          touchAction: 'manipulation',
          userSelect: 'none',
          WebkitTapHighlightColor: 'transparent'
        }}
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
          <path d="M2 10a8 8 0 1116 0 8 8 0 01-16 0zm6.5-4.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm7 0a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0zm-7 7a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm7 0a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0z" />
        </svg>
        <span className="text-xs mt-1 font-medium">Positions</span>
      </button>
      
      <button
        onClick={handleChartClick}
        className={`flex flex-col items-center px-4 py-3 rounded-lg transition-all active:scale-95 ${
          isChartPaneOpen ? 'bg-[#7900ff]/20 text-[#7900ff]' : 'text-gray-400'
        }`}
        style={{
          /* Botão clicável */
          minHeight: '60px',
          minWidth: '60px',
          touchAction: 'manipulation',
          userSelect: 'none',
          WebkitTapHighlightColor: 'transparent'
        }}
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
          <path d="M2 11a1 1 0 011-1h2a1 1 0 011 1v5a1 1 0 01-1 1H3a1 1 0 01-1-1v-5zm6-4a1 1 0 011-1h2a1 1 0 011 1v9a1 1 0 01-1 1H9a1 1 0 01-1-1V7zm6-3a1 1 0 011-1h2a1 1 0 011 1v12a1 1 0 01-1 1h-2a1 1 0 01-1-1V4z" />
        </svg>
        <span className="text-xs mt-1 font-medium">Chart</span>
      </button>
      
      <button
        onClick={handleHistoryClick}
        className={`flex flex-col items-center px-4 py-3 rounded-lg transition-all active:scale-95 ${
          isHistoryPaneOpen ? 'bg-[#7900ff]/20 text-[#7900ff]' : 'text-gray-400'
        }`}
        style={{
          /* Botão clicável */
          minHeight: '60px',
          minWidth: '60px',
          touchAction: 'manipulation',
          userSelect: 'none',
          WebkitTapHighlightColor: 'transparent'
        }}
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
        </svg>
        <span className="text-xs mt-1 font-medium">History</span>
      </button>
    </div>
  );
};

export default MobileMenu;
